import { getFiltersApi, getContinuousFeedbackApi } from 'api/analytics/continuousFeedback';

import { GroupByKeys } from './reviewHelper';

export const getFilters = () =>
  getFiltersApi().then((res) => ({
    ...res.entity,
    // cohorts: res.entity.cohort.map( ch => Cohort.fromJSON(ch)),
    cohorts: res.entity.cohort,
    groupByKeys: res.entity.groupByKeys.map((key) => GroupByKeys.fromJSON(key)),
    splitByKeys: res.entity.splitByKeys || [],
  }));

export const getContinuousFeedback = ({
  isExpandedViewRequired = false,
  cohort,
  groupByKeys,
  splitByKeys,
  parentUuid,
  orderBy = {},
  dateRange,
}) => {
  const queryParams = {
    isExpandedViewRequired,
  };
  if (orderBy.columnId === null) orderBy = null;
  else orderBy = [orderBy];

  return getContinuousFeedbackApi({
    cohort,
    groupByKeys,
    splitByKeys,
    parentUuid,
    orderBy,
    dateRange,
    queryParams,
  }).then((res) => res.entity);
};
